import * as React from 'react';
import { ArticleHeading2, ArticleParagraph1 } from '@cian/ui-kit';

import { IconActionArrowRight16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './ListingCompilation.css';

interface IListingCompilationProps {
  imageUrl: string;
  subtitle: string;
  title: string;
  url: string;
}

export const ListingCompilation: React.FC<IListingCompilationProps> = ({ imageUrl, subtitle, title, url }) => {
  return (
    <a className={styles['container']} href={url} target="_blank" rel="noopener noreferrer">
      <div className={styles['top']}>
        <div className={styles['image']} style={{ backgroundImage: `url(${imageUrl})` }} />
        <div className={styles['arrow-button']}>
          <IconActionArrowRight16 color="primary_100" />
        </div>
      </div>
      <div className={styles['bottom']}>
        <ArticleHeading2>{title}</ArticleHeading2>
        <ArticleParagraph1>{subtitle}</ArticleParagraph1>
      </div>
    </a>
  );
};
